import EmberObject from '@ember/object';

import * as OpAmpNegCurrent from './noise-sources/op-amp-neg-current';
import * as OpAmpPosCurrent from './noise-sources/op-amp-pos-current';
import * as OpAmpVoltage from './noise-sources/op-amp-voltage';
import * as R1 from './noise-sources/r1';
import * as R3 from './noise-sources/r3';
import * as R4 from './noise-sources/r4';
import FilterConstants from '../../../../filter-constants';

export default class FirstOrderLowPassNoiseSource extends EmberObject {
  c1 = null;
  r1 = null;
  r3 = null;
  r4 = null;
  opAmp = null;
  _r1Noise(filterAmplitude, sImaginary) {
    var baseAmplitudeCopy = filterAmplitude;
    var r1 = this.r1;
    var c1 = this.c1;
    var complexAlphaPlus = R1.computeComplexAlphaPlus(c1, r1, sImaginary);
    var complexFF = R1.computeComplexFF();
    var value = Math.sqrt(r1 / 1000) * FilterConstants.resistorNoiseBase;
    var magnitude = baseAmplitudeCopy.computeMagnitude(complexAlphaPlus, complexFF);
    var result = value * magnitude;
    return result;
  }

  _r3Noise(filterAmplitude, complexRParallel) {
    var baseAmplitudeCopy = filterAmplitude;
    var r3 = this.r3;
    var r4 = this.r4;
    var complexAlphaPlus = R3.computeComplexAlphaPlus(r3, r4);
    var complexFF = R3.computeComplexFF(complexRParallel, r3, r4);
    var value = Math.sqrt(r3 / 1000) * FilterConstants.resistorNoiseBase;
    var magnitude = baseAmplitudeCopy.computeMagnitude(complexAlphaPlus, complexFF);
    var result = value * magnitude;
    return result;
  }

  _r4Noise(filterAmplitude, complexRParallel) {
    var baseAmplitudeCopy = filterAmplitude;
    var r3 = this.r3;
    var r4 = this.r4;
    var complexAlphaPlus = R4.computeComplexAlphaPlus(r3, r4);
    var complexFF = R4.computeComplexFF(complexRParallel, r3, r4);
    var value = Math.sqrt(r4 / 1000) * FilterConstants.resistorNoiseBase;
    var magnitude = baseAmplitudeCopy.computeMagnitude(complexAlphaPlus, complexFF);
    var result = value * magnitude;
    return result;
  }

  _opAmpNegCurrent(filterAmplitude, complexRParallel) {
    var baseAmplitudeCopy = filterAmplitude;
    var r3 = this.r3;
    var r4 = this.r4;
    var complexAlphaPlus = OpAmpNegCurrent.computeComplexAlphaPlus(r3, r4);
    var complexFF = OpAmpNegCurrent.computeComplexFF(complexRParallel, r3, r4);
    var value = this.opAmp.iNoise;
    var magnitude = baseAmplitudeCopy.computeMagnitude(complexAlphaPlus, complexFF);
    var result = value * magnitude;
    return result;
  }

  _opAmpPosCurrent(filterAmplitude, sImaginary) {
    var baseAmplitudeCopy = filterAmplitude;
    var c1 = this.c1;
    var r1 = this.r1;
    var complexAlphaPlus = OpAmpPosCurrent.computeComplexAlphaPlus(c1, r1, sImaginary);
    var complexFF = OpAmpPosCurrent.computeComplexFF();
    var value = this.iNoise;
    var magnitude = baseAmplitudeCopy.computeMagnitude(complexAlphaPlus, complexFF);
    var result = value * magnitude;
    return result;
  }

  _opAmpVoltage(filterAmplitude) {
    var baseAmplitudeCopy = filterAmplitude;
    var complexAlphaPlus = OpAmpVoltage.computeComplexAlphaPlus();
    var complexFF = OpAmpVoltage.computeComplexFF();
    var value = this.vNoise;
    var magnitude = baseAmplitudeCopy.computeMagnitude(complexAlphaPlus, complexFF);
    var result = value * magnitude;
    return result;
  }

  totalNoise(filterAmplitude, complexRParallel, sImaginary) {
    var r1Noise = this._r1Noise(filterAmplitude, sImaginary);
    var r3Noise = this._r3Noise(filterAmplitude, complexRParallel);
    var r4Noise = this._r4Noise(filterAmplitude, complexRParallel);
    var opAmpNegCurrent = this._opAmpNegCurrent(filterAmplitude, complexRParallel);
    var opAmpPosCurrent = this._opAmpPosCurrent(filterAmplitude, sImaginary);
    var opAmpVoltage = this._opAmpVoltage(filterAmplitude);
    var noiseArray = [r1Noise, r3Noise, r4Noise, opAmpNegCurrent, opAmpPosCurrent, opAmpVoltage];
    var sumOfSquares = 0;

    noiseArray.forEach((item) => {
      sumOfSquares += item * item;
    });

    var result = Math.sqrt(sumOfSquares);
    return result;
  }
}
